import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from "@/components/layout/Layout";

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: '',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: () => import('@/views/LogIn')
    },
    {
      path: '/ResetView',
      name: 'ResetView',
      component: () => import('@/views/ResetView.vue')
    },
    {
      path:'/otp',
      name:'Otp',
      component: () => import('@/views/Otp')
    },
    {
      path:'/signup',
      name:'smartInitialized',
      component: () => import('@/views/SmartInitiazation.vue')
    },
    {
      path:'/agentOtp',
      name:'SmartInvoiceOtp',
      component: () => import('@/views/SmartInvoiceOtp.vue')
    },
    {
      path:'/setup',
      name:'Branch',
      component: () => import('@/views/Branch.vue')
    },
    {
      path: '/',
      component: Layout,
      children: [
        {
          path:'/QueryLogs',
          name:'QueryLogs',
          component: () => import('@/views/QueryLogs')
        },
        {
          path:'/DepartmentConfig',
          name:'DepartmentConfig',
          component: () => import('@/views/DepartmentConfig')
        },
        {
          path:'/stock',
          name:'stock',
          component: () => import('@/views/StockViewer.vue')
        },
        {
          path:'/SystemCode',
          name:'SystemCode',
          component: () => import('@/views/SystemCode')
        },
        {
          path:'/currency-config',
          name:'currency-config',
          component: () => import('@/views/CurrencyConfig')
        },
        {
          path:'/invoices',
          name:'InvoicesView',
          component: () => import('@/views/InvoicesView.vue')
        },
        {
          path:'/country-config',
          name:'country-config',
          component: () => import('@/views/CountryConfig')
        },
        {
          path:'/tax-types',
          name:'tax-types',
          component: () => import('@/views/TaxLabelsConfig')
        },
        {
          path:'/UserManagment',
          name:'UserManagment',
          component: () => import('@/views/UserManagment.vue')
        },
        {
          path:'/Chart',
          name:'Chart',
          component: () => import('@/views/Chart.vue')
        },
        {
          path:'/GRV',
          name:'GRV',
          component: () => import('@/views/GRV')
        },
        {
          path:'/import',
          name:'import',
          component: () => import('@/views/Imports.vue')
        },
        {
          path:'/settings',
          name:'settings',
          component: () => import('@/views/Settings.vue'),
          meta: { requiresOfflineVsdc: true }
        },
      ]
    }

  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.requiresOfflineVsdc && window.isOnlineVsdc === true) {
    // Block Settings in Online VSDC mode
    return next({ name: 'QueryLogs' });
  }
  next();
});

export default router
